const KEY = 'voice_notice_seen';

/** Returns true if the one-time mic privacy notice still needs showing. */
export function shouldShowVoiceNotice(): boolean {
  return localStorage.getItem(KEY) !== 'true';
}

export function markVoiceNoticeSeen(): void {
  localStorage.setItem(KEY, 'true');
}
